/* eslint-disable @typescript-eslint/no-explicit-any */
import { init, Models, RematchRootState, ModelEffects } from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
import models from './models/models';

const loadingOptions = { asNumber: false };
const loadingPlugin = createLoadingPlugin(loadingOptions);
const store = init({
  models,
  plugins: [loadingPlugin]
});

export default store;

export type Dispatch = typeof store.dispatch;

type ExtractRematchLoadingStateFromEffectsObject<
  Effects extends ModelEffects<any>
> = {
  [effectKey in keyof Effects]: boolean;
};

interface LoadingState<M extends Models> {
  loading: {
    global: boolean;
    models: { [modelName in keyof M]: boolean };
    effects: {
      [modelName in keyof M]: ExtractRematchLoadingStateFromEffectsObject<
        ModelEffects<any>
      >;
    };
  };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export type iRootState = RematchRootState<typeof models> &
  LoadingState<typeof models>;
